import FlipInfo from './src/main';

/* istanbul ignore next */
FlipInfo.install = function(Vue) {
  Vue.component(FlipInfo.name, FlipInfo);
};

export default FlipInfo;
